"use strict";
/**
 * Signup Popup Dismiss
 * Marks the newsletter popup as seen once the visitor has a customer account.
 *
 * theme.js writes its long-lived "already seen" cookie only when it finds a
 * `.note--success` inside the popup, which is the newsletter contact-form flow.
 * The account signup variant has no such success state — it registers the customer
 * and moves them on — so the cookie was never written and the popup came straight
 * back on the next page.
 *
 * newsletter-popup.liquid already hides the popup outright while they are signed
 * in; writing the cookie as well keeps it dismissed if they later sign out. Keying
 * off the customer session rather than the form's submit event means this holds
 * however the account was created (native form, Custom Forms app, Sign up with
 * Shop) and never fires for an attempt that failed validation.
 *
 * Uses the same cookie name, value and path as theme.js so the two agree.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var COOKIE_VALUE = 'opened';
var COOKIE_DAYS = 200;
function signupPopupDismiss() {
    var marker = document.querySelector('[data-newsletter-popup-seen]');
    var sectionId = marker === null || marker === void 0 ? void 0 : marker.dataset.newsletterPopupSeen;
    if (!sectionId)
        return;
    var expires = new Date(Date.now() + COOKIE_DAYS * 86400000).toUTCString();
    document.cookie = "newsletter-" + sectionId + "=" + COOKIE_VALUE + ";path=/;expires=" + expires;
}
exports.default = signupPopupDismiss;
